"use client";

const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/alerts/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { alternatesToLinks, buildCanonicalAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/alerts/")({
  head: async ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "alerts"
    });
    const alts = buildCanonicalAlternates("/alerts");
    return {
      meta: await buildPagePreviewMetaTags({
        title: t("metadataTitle"),
        description: t("metadataDescription"),
        canonicalUrl: alts.canonical
      }, {
        openGraph: {
          type: "website"
        },
        twitter: {}
      }, {
        locale
      }),
      links: alternatesToLinks(alts)
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});